import { C as e, F as t, P as n, R as r, S as i, U as a, _ as o, at as s, g as c, h as l, ot as u, p as d, q as f, t as p, v as m, w as h } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { t as g } from "./Button.ce-Dstoud2U.js";
import { t as _ } from "./FocusManager.ce-B0sbbTnb.js";
//#region src/webcomponents/common/Popin.ce.vue?vue&type=script&setup=true&lang.ts
var v = {
	key: 0,
	class: "overlay"
}, y = ["aria-label"], b = { class: "pop-in__header" }, x = { class: "pop-in__title" }, S = {
	id: "content",
	class: "pop-in__content"
}, C = /*#__PURE__*/ p(/* @__PURE__ */ h({
	__name: "Popin.ce",
	props: {
		title: { type: String },
		content: { type: String },
		textButton: { type: String },
		buttonPosition: {
			default: "right",
			type: String
		},
		show: { type: Boolean }
	},
	emits: ["primaryAction"],
	setup(p) {
		let h = a("pop-in"), C = {
			left: "start",
			center: "center",
			right: "end"
		};
		return n(() => {
			!p.textButton && p.show && h.value?.focus();
		}), (n, a) => (t(), m(d, null, [p.show ? (t(), m("div", v)) : o("", !0), e(_, {
			"is-visible": p.show,
			loop: !!p.textButton
		}, {
			default: f(() => [l("div", {
				ref: "pop-in",
				role: "dialog",
				class: "pop-in",
				"aria-label": p.title,
				"aria-describedBy": "content",
				tabindex: "-1"
			}, [l("div", b, [l("h1", x, [r(n.$slots, "title", {}, () => [i(u(p.title), 1)])]), l("p", S, [r(n.$slots, "content", {}, () => [i(u(p.content), 1)])])]), p.textButton ? (t(), c(g, {
				key: 0,
				class: "pop-in__button",
				style: s({ "--button-position": C[p.buttonPosition] }),
				onClick: a[0] ||= (e) => n.$emit("primaryAction")
			}, {
				default: f(() => [i(u(p.textButton), 1)]),
				_: 1
			}, 8, ["style"])) : o("", !0)], 8, y)]),
			_: 3
		}, 8, ["is-visible", "loop"])], 64));
	}
}), [["styles", [".overlay{z-index:200;background-color:#25385859;border-radius:8px;position:absolute;inset:0}.pop-in{z-index:300;background-color:#fff;border-radius:16px;flex-direction:column;gap:16px;width:min(560px,95%);padding-bottom:24px;display:flex;position:absolute;top:40%;left:50%;transform:translate(-50%,-50%);box-shadow:0 2px 5px #4a3aff40,inset 0 -2px 5px #4a3aff26,inset 0 1px 1px #ffffff1a,inset 0 3px 4px #dfeeff1a}.pop-in__header{background:linear-gradient(#613fdd33 0%,#613fdd1a 40%,#fff 100%);border-radius:16px 16px 0 0;padding:24px}.pop-in__title{font-size:1.25rem;font-weight:700}.pop-in__content{font-family:Roboto,sans-serif;font-size:.875rem}.pop-in__button{align-self:var(--button-position);margin-right:24px;font-family:Roboto,sans-serif;font-weight:700}"]]]);
//#endregion
export { C as t };
